import { render, staticRenderFns } from "./UserOverviewNotesCreate.vue?vue&type=template&id=aef59f86&scoped=true&"
import script from "./UserOverviewNotesCreate.vue?vue&type=script&lang=js&"
export * from "./UserOverviewNotesCreate.vue?vue&type=script&lang=js&"
import style0 from "./UserOverviewNotesCreate.vue?vue&type=style&index=0&id=aef59f86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aef59f86",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VCol,VDialog,VRow,VTextarea})
